import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { APP_DEFAULT_PATH } from 'config';
import { getStoredAuth } from 'utils/auth';

export function RequireAuth({ children }) {
  const auth = getStoredAuth();
  const user = auth && typeof auth === 'object' ? auth.user : null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export function RequireGuest({ children }) {
  const auth = getStoredAuth();
  const user = auth && typeof auth === 'object' ? auth.user : null;

  if (user) {
    return <Navigate to={APP_DEFAULT_PATH} replace />;
  }

  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.node.isRequired
};

RequireGuest.propTypes = {
  children: PropTypes.node.isRequired
};
